export enum DashboardOrder {
  Asc = 'Asc',
  Desc = 'Desc',
}
